export default __webpack_public_path__ + "static/media/icons8-food-bar-100.1d409aa1.svg";